<template>
  <div class="answerList">
    <bread-crumb></bread-crumb>
    <man-form-list
      :select="select"
      :selectList="selectList"
      @getChangeValue="getQueryData"
      :isBtn="1"
      @empty="empty"
      @disease_remoteMethod="getDiseases"
      @doctor_remoteMethod="getDoctor"
      :isShowFilter="isShowFilter"
      @searchFilter="searchFilter"
      @checkBoxedChange="checkBoxedChange"
      @clickSingleBoxed="clickSingleBoxed"
      @popHide="popHide"
      :searchFilterList="searchFilterList"
      :checkList="checkList"
    ></man-form-list>
    <div class="tbl">
      <el-row class="import-btn" type="flex" justify="end">
        <!-- 导出文章 -->
        <div class="exportBtn" v-if="userInfo.tenantManager">
          <el-button
            type="primary"
            size="mini"
            @click="dialogContentVisible = true"
            >数据导出(1次最多1w条)
          </el-button>
        </div>
        <div class="importBtn">
          <el-button
            type="danger"
            v-if="isExportArticleShow"
            @click="downloadDiles(6)"
            >导出失败
          </el-button>
        </div>
      </el-row>
      <el-tabs v-model="tabActiveName" @tab-click="tabHandleClick">
        <el-tab-pane
          :label="item.name"
          :name="item.name"
          v-for="item in questionTabList"
          :key="item.name"
        >
          <span slot="label" class="slot-item">
            <span>{{ item.name }}</span
            ><span>{{ item.count }}</span>
          </span>
          <Sort
            :tabActiveName="tabActiveName"
            :type="1"
            ref="Sort"
            @getSortData="getSortData"
            :tabIndex="tabIndex"
            v-if="sonRefresh"
          />
          <div class="base-table">
            <div class="base-table-table">
              <el-table :data="tblData" style="width: 100%">
                <el-table-column label="问题ID">
                  <template slot-scope="scope">
                    <div
                      v-for="(item, index) in scope.row.contentRelations"
                      :key="index"
                    >
                      <span v-if="item.relationType == 1">{{
                        item.contentId
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="contentId"
                  label="答案ID"
                ></el-table-column>
                <el-table-column label="问题">
                  <template slot-scope="scope">
                    <div
                      v-for="(item, index) in scope.row.contentRelations"
                      :key="index"
                    >
                      <span v-if="item.relationType == 1">{{
                        item.contentName
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="提问人">
                  <template slot-scope="scope">
                    <div
                      v-for="(item, index) in scope.row.contentRelations"
                      :key="index"
                    >
                      <span v-if="item.relationType == 1">{{
                        item.createUser
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="回答人">
                  <template slot-scope="scope">
                    <div
                      v-for="(item, index) in scope.row.authors"
                      :key="index"
                    >
                      <span v-if="item.authorType == 2">{{
                        item.authorName +
                        " " +
                        item.titleName +
                        " " +
                        item.authorId +
                        " " +
                        item.hospitalName
                      }}</span>
                      <span v-if="item.authorType == 5"
                        >{{ item.authorName != "" ? item.authorName : "" }}
                        {{ item.titleName != "" ? item.titleName : "" }}
                        {{
                          item.hospitalName != "" ? item.hospitalName : ""
                        }}</span
                      >
                    </div>
                  </template>
                </el-table-column>
                <!-- 内容质量 -->
                <el-table-column
                  label="内容质量"
                  prop="contentAttributes"
                  width="120"
                >
                  <template #header>
                    <div style="display: flex">
                      <span>内容质量</span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="内容质量来源于内容的基本素质和用户反馈等维度，“优秀”将获得更多的曝光机会"
                        placement="bottom-start"
                      >
                        <img
                          src="@/assets/mark.svg"
                          style="width: 15px; height: 15px"
                        />
                      </el-tooltip>
                    </div>
                  </template>
                  <template slot-scope="scope">
                    <div
                      v-for="item in scope.row.contentAttributes"
                      :key="item.id"
                    >
                      <span v-if="item.type == 29">{{ item.desc }}</span>
                    </div>
                  </template>
                </el-table-column>
                <!-- 总浏览量 -->
                <el-table-column label="总浏览量" width="120">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.contentStatistics &&
                      scope.row.contentStatistics.browseCount
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="回答时间">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.submitTime || scope.row.createTime | time
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="审核时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.auditInfo.auditTime | time }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="审核人">
                  <template slot-scope="scope">
                    <span>{{ scope.row.auditInfo.auditUser }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="问答来源">
                  <template slot-scope="scope">
                    <div v-for="item in questionFrom">
                      <span v-if="scope.row.sourceType === item.value">{{
                        item.label
                      }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="审核状态">
                  <template slot-scope="scope">
                    <span
                      v-if="[2, 3].includes(scope.row.auditInfo.auditStatus)"
                      :class="
                        scope.row.auditInfo.auditStatus == 3
                          ? 'adopt-color'
                          : 'reviewed-color'
                      "
                    ></span>
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.auditInfo.remark"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.auditInfo.auditStatus == 4"
                    >
                      <div
                        :class="
                          scope.row.auditInfo.auditStatus == 4 ? 'rejected' : ''
                        "
                      >
                        {{ scope.row.auditInfo.auditStatus | auditStatus }}
                        <i class="el-icon-warning-outline"></i>
                      </div>
                    </el-tooltip>
                    <div v-else style="display: inline-block">
                      {{ scope.row.auditInfo.auditStatus | auditStatus }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="问答状态">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.statusInfo.remark"
                      placement="top"
                      style="display: inline-block"
                      v-if="scope.row.contentStatus == 2"
                    >
                      <div
                        :class="scope.row.contentStatus == 2 ? 'rejected' : ''"
                      >
                        {{ scope.row.contentStatus == 1 ? "已上线" : "已下线" }}
                        <i
                          class="el-icon-warning-outline"
                          v-if="scope.row.contentStatus == 2"
                        ></i>
                      </div>
                    </el-tooltip>
                    <div v-else-if="scope.row.contentStatus">
                      {{ scope.row.contentStatus == 1 ? "已上线" : "已下线" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        v-if="scope.row.auditInfo.auditStatus == 2"
                        @click="operate(scope.row)"
                        >审核</el-button
                      >
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        v-else-if="
                          scope.row.auditInfo.auditStatus == 4 ||
                          [1, 2].indexOf(scope.row.contentStatus) > -1 ||
                          scope.row.auditInfo.auditStatus == 1
                        "
                        @click="operate(scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        v-if="scope.row.contentStatus == 1"
                        @click="redirectTo(scope.row)"
                        >查看线上</el-button
                      >
                      <el-button
                        class="operateBtn"
                        type="text"
                        size="small"
                        @click="
                          dialogOfflineVisible = true;
                          operatingRow = scope.row;
                        "
                        v-if="scope.row.contentStatus == 1"
                        >下线</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <pagination
        @sizePageChange="
          (val) => {
            pagination = val;
            getPageData();
          }
        "
        :paginationDatas="pagination"
      />
    </div>
    <!--上传-->
    <el-dialog
      title="批量上传"
      :visible.sync="dialogImportVisible"
      @close="dialogImportVisible = false"
    >
      <el-upload
        class="upload-demo"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        :limit="1"
        :before-upload="beforeUpload"
        :http-request="upload"
        :file-list="fileList"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <el-button size="small" type="text" @click="downloadTemplate"
          >下载上传模板</el-button
        >
        <div slot="tip" class="el-upload__tip">
          <p>注： 1、请上传Excel文件，列表不超过1000行</p>
          <p>2、上传过程中请勿刷新</p>
        </div>
      </el-upload>
    </el-dialog>
    <!--导出问答-->
    <el-dialog
      title="批量导出问答"
      :visible.sync="dialogContentVisible"
      width="30%"
      @close="closeOutDialog"
    >
      <div
        style="
          margin-top: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-button
          type="primary"
          size="medium"
          :loading="uploadShow"
          @click="getOutArticleCategory()"
          style="width: 93px"
        >
          {{ uploadShow ? "导出中" : "导出" }}
        </el-button>
      </div>
    </el-dialog>
    <!--下线-->
    <modal
      :isShow.sync="dialogOfflineVisible"
      title="下线"
      width="800px"
      :isShowBtn="[true, true]"
      :btnText="['取消', '确认']"
      @clickHandler="offlineClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px" class="offlineForm">
        <span class="red">*</span>
        <el-form-item label="下线理由">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入下线理由，不超过200字"
            v-model="offLineReasons"
            :autosize="{ minRows: 4, maxRows: 6 }"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>
<script>
// 组件
import breadCrumb from "@/components/breadCrumb";
import pagination from "@/components/pagination";
import modal from "@/components/modal";
import ManFormList from "@/entrys/man/components/manFormList";
import Sort from "../../components/sort";
import {
  getOutArticleCategory,
  uploadCategoryExl,
  fileChange,
} from "../../components/importExportCommon";
// api
import {
  queryDiseaseLibraryName,
  queryDoctorName,
  querySource,
  getContentStatus,
  queryBusiness,
  // TODO替换成新的问题列表接口
  queryQuestionList,
  queryQuestionStateNum,
  offlineApplication,
  importQuestionAnswer,
} from "@/api/questionsLibrary";
import {
  manSaveUserConfig,
  manListUserConfig,
  listContentBusinessForUserMan,
} from "@/api/man";
import {
  getContentQuailty,
  getDistributionScope,
  searchDataProcessing,
  getGeneralLabel,
} from "../contentManage/distribution";
import { request } from "@/utils/axios";
import { manListContentIndexTree } from "@/api/indexs";
// 工具类
import utils from "@/utils";
import { mapState } from "vuex";
const baseUrl = process.env.VUE_APP_BASEURL;

export default {
  name: "answerList",
  components: {
    ManFormList,
    breadCrumb,
    pagination,
    modal,
    Sort,
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  data() {
    return {
      sonRefresh: true,
      // 问题的内容类型，公共参数，下面所有用到的接口统一使用该变量
      contentType: 15, // 15-回答
      baseUrl,
      configId: null,
      checkList: [1000],
      allSearchList: [],
      serverList: [],
      qualityList: [], // 内容质量
      businessList: [],
      articleLabels: [], // 内容标签
      indexTreeList: [],
      businessChannelArr: [],
      isShowFilter: 1,
      rangeList: [], // 分发范围
      contentAttributes: [],
      answerStatusList: [],
      // 搜索FORM字段，传给FORM组件初始化字段使用
      select: [
        {
          prop: "questionId",
          type: "input2",
          placeholder: "请输入问题ID",
          maxLenth: 18,
        },
      ],
      select1: [
        {
          prop: "questionId",
          type: "input2",
          placeholder: "请输入问题ID",
          maxLenth: 18,
        },
        {
          prop: "answerId",
          type: "input2",
          placeholder: "请输入答案ID",
          maxLenth: 18,
        },
        {
          prop: "contentName",
          type: "input",
          placeholder: "请输入标题关键词检索",
          maxLenth: 50,
        },
        {
          prop: "searchKeyword",
          type: "input",
          placeholder: "请输入全文关键词检索",
          maxLenth: 50,
        },
        {
          prop: "answerTime",
          type: "picker",
          placeholder: "请选择回答时间",
        },
        {
          prop: "symptomsDisease",
          type: "disease",
          placeholder: "请输入疾病",
          maxLenth: 50,
          List: [],
        },
        {
          prop: "answerer",
          type: "originSearch",
          placeholder: "请输入回答人",
          maxLenth: 50,
          List: [],
        },
        {
          prop: "questionSource",
          type: "select",
          placeholder: "请选择问答来源",
          List: [],
        },
        {
          prop: "answerStatus",
          type: "select",
          placeholder: "请选择答案状态",
          List: [],
        },
        {
          prop: "publishStatus",
          type: "select",
          placeholder: "请选择公开状态",
          List: [
            {
              value: 1,
              label: "公开",
            },
            {
              value: 2,
              label: "屏蔽",
            },
          ],
        },
        {
          prop: "contentIndexIds",
          type: "selectIndex",
          placeholder: "请选择索引",
          List: [],
        },
      ],
      // 搜索FORM初始值
      selectList: {
        questionId: "", // 问题ID
        answerId: "", // 答案ID
        contentName: "", // 标题
        searchKeyword: "", // 全文
        answerTime: [], // 回答时间
        symptomsDisease: null, // 疾病症状
        docId: "", // 回答人是内部医生的情况下
        authorNamePrecise: "", // 回答人不是内部医生
        answerer: "", // 回答人
        questionSource: [], // 问答来源
        answerStatus: "", // 回答状态
        publishStatus: null, // 公开状态 1. 公开 2. 屏蔽
        auditTime: [], //
        writerPin: "",
        nickname: "",
        range: "",
        hospital: "",
        quality: "",
        business: [], // 所属业务
        categoryId: "", // 所属栏目
        channelId: "", // 所属频道
        contentIndexIds: [], // 索引
        contentDiseasesNotNull: "",
        isDoctor: "",
        sortOrderParams: [],
      },

      // ------------------- 批量导入 start ---------------------
      // 导入弹出是否显示标识
      dialogImportVisible: false,
      // 批量上传
      fileList: [],
      // 导出问答失败
      isExportArticleShow: false,
      failExportArticleUrl: "",
      // 问答导出弹出是否显示标识
      dialogContentVisible: false,
      uploadShow: false,
      // ------------------- 批量导入 end ---------------------
      // ------------------- 下线弹层 start ---------------------
      // 下线弹窗填写下线理由
      dialogOfflineVisible: false,
      // 下线理由文本
      offLineReasons: "",
      // ------------------- 下线弹层 end ---------------------
      // tab页
      // 当前激活tab
      tabActiveName: "全部",
      // tab列表数据
      questionTabList: [
        {
          name: "全部",
          count: 0,
          val: [1, 2, 3, 4],
        },
        {
          name: "待审核",
          count: 0,
          val: [2],
        },
        {
          name: "已通过",
          count: 0,
          val: [3],
        },
        {
          name: "已驳回",
          count: 0,
          val: [4],
        },
      ],
      // 当前操作行的数据
      operatingRow: null,
      // 表格
      tblData: [],
      // 分页
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      questionFrom: [], // 记录内容来源
      tabChange: 0, // tab切换的变量  用来区分是否需要更新tab后面的数量
      tabIndex: 0,
    };
  },
  async created() {
    // 查询用户保存配置
    await this.queryUserConfig();
    //  获取天空之城数据
    await this.queryFloorList();
    this.getDistributionScope(); // 获取分发范围
    // 获取内容质量
    this.getContentQuailty();
    this.listContentBusinessForUserMan();
    // 获取标签
    this.getGeneralLabel();
    this.initData();
    this.getIndexTreeList();
  },
  mounted() {
    document.addEventListener("visibilitychange", this.handlePageVisible);
  },
  destroyed() {
    document.removeEventListener("visibilitychange", this.handlePageVisible);
    sessionStorage.removeItem("openContentId");
  },
  filters: {
    auditStatus(data) {
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "审核通过";
        case 4:
          return "已驳回";
      }
    },
    time(data) {
      if (data) {
        return utils.timetamp(data);
      }
    },
  },
  methods: {
    getSortData(val) {
      console.log("val", val);
      this.selectList.sortOrderParams = val;
      this.getData();
    },
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      manListContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        this.indexTreeList = res;
        this.select.map((subItem) => {
          if (subItem.prop == "contentIndexIds") {
            subItem.List = res;
          }
        });
        console.log(
          "======1=23=3030383282894u8438u239409====",
          this.indexTreeList
        );
        // const index = this.select.findIndex((item) => item.type === 'selectIndex');
        // this.select[index].List = res;
      });
    },
    // 过滤
    searchFilter() {},
    // 配置项勾选
    checkBoxedChange(value) {},
    // 点击
    clickSingleBoxed(checked, item) {
      console.log("clickSingleBoxed======>", checked, item);
      if (checked) {
        // 添加
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            this.configSubItem(busItem);
            this.select.push(busItem);
          });
          this.checkList.push(item.cfgID);
        } else {
          this.checkList.push(item.cfgID);
          this.configSubItem(item);
          this.select.push(item);
        }
      } else {
        // 删除
        this.checkList = this.checkList.filter((value) => {
          if (value == item.cfgID) return false;
          return true;
        });
        if (item.cfgID == 4000) {
          this.businessChannelArr.map((busItem) => {
            busItem.List = [];
            this.selectList[busItem.prop] = "";
          });
        } else {
          this.selectList[item.prop] = "";
        }
        this.select = this.select.filter((value) => {
          if (value.cfgID == item.cfgID) return false;
          return true;
        });
      }
      let selecrData = JSON.stringify(this.select);
      sessionStorage.setItem("disBuSelectData", selecrData); // 存入筛选选择数据
    },
    configSubItem(subItem) {
      if (subItem.cfgID == 3004) {
        let arr = this.qualityList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 3003) {
        let arr = this.rangeList.map((item) => {
          return { value: item.id, label: item.desc };
        });
        subItem.List = arr;
      }
      if (subItem.cfgID == 3005) {
        subItem.List = this.answerStatusList;
      }
      if (subItem.cfgID == 4000 && subItem.prop == "business") {
        subItem.List = this.businessList;
      }
      if (subItem.cfgID == 4001) {
        subItem.List = this.articleLabels;
      }
      if (subItem.cfgID == 4002) {
        subItem.List = this.indexTreeList;
      }
      if (subItem.cfgID == 5004) {
        subItem.List = this.questionFrom;
        // console.log('this=======', this.questionFrom, subItem.prop);
        // this.selectList[subItem.prop] = ['全部', ...this.questionFrom.map(subItem => subItem.value)];
      }
      // if ([3000,3001,3002,3003,3004,3005,5002,5003].includes(subItem.cfgID)){
      //     this.selectList[subItem.prop] = "全部";
      // }
    },
    // 配置项隐藏
    popHide(value) {
      console.log(value, "contentAudit--popHide");
      this.saveUserConfig({
        configId: this.configId,
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "5",
        value: value.toString(),
      });
    },
    // 获取天空之城数据 生成页面数据
    async queryFloorList() {
      await request("jdh_laputa_queryFloorList", {
        functionId: "answerReOnOff",
        appId: "21557c5d3d0a4ec1b0184719022bb4b5",
        osName: "jdhwiki",
        venderId: null,
        inquiryTenancyId: null,
        version: 3,
      })
        .then(async (res) => {
          // this.floorTransferDTOS = res?.cf?.floorTransferDTOS;
          // console.log(res?.cf?.floorTransferDTOS[0], 'contentAudit<----来了哥----->');
          //  处理天空之城数据
          const cfgArray = res?.cf?.floorTransferDTOS[0].cfgList.filter(
            (item) => {
              if (item?.name == "manuDataCfg") {
                return true;
              }
              return false;
            }
          );
          // 整体配置数据
          let valueArray = JSON.parse(cfgArray[0].value).map((item) => {
            return JSON.parse(item?.value);
          });
          // console.log(valueArray, 'contentAudit<----来了哥----->valueArray');
          let fileterArray = [];
          let allShowSearchArr = [];
          // console.log( '=====>|||||========>',valueArray);
          // 所有配置的数据 包括 ids
          valueArray.map((item) => {
            let filerItem = this.$commonJs.deepClone(item);
            if (!Array.isArray(filerItem?.selectedIDs)) {
              // 获取搜索筛选总的展示
              filerItem.selectItems = filerItem?.selectItems.filter(
                (subItem) => {
                  return subItem.isShow;
                }
              );
              fileterArray.push(filerItem);

              item.selectItems = item?.selectItems.map((subItem) => {
                if (subItem.cfgID == 4000) {
                  this.businessChannelArr.push(subItem);
                }
                return subItem;
              });
              allShowSearchArr.push(item);
            } else {
              if (this.serverList?.length == 0) {
                // console.log('==============ppppppppp');
                this.checkList = item?.selectedIDs;
              }
            }
          });
          this.allSearchList = allShowSearchArr;
          // 搜索筛选弹框展示的数据
          this.searchFilterList = fileterArray;
          // console.log(fileterArray, '拿到我配置的数据');

          // 页面上展示搜索
          let tempSelectList = [];
          this.checkList.map((cItem) => {
            allShowSearchArr.map((item) => {
              item?.selectItems?.map((subItem) => {
                if (cItem == subItem.cfgID) {
                  tempSelectList.push(subItem);
                }
              });
            });
          });
          // allShowSearchArr.map((item) => {
          //     // console.log(item, '========>|||||||');
          //     item?.selectItems?.map((subItem) => {
          //         if (this.checkList.includes(subItem.cfgID)) {
          //           tempSelectList.push(subItem);
          //         }
          //     })
          // })
          // 显示的搜索弹框
          this.select = tempSelectList;
          // console.log(this.select, 'queryFloorList=====>|||||======');
        })
        .catch((err) => {
          this.$message.error(err.msg || "查询失败");
        });
      // console.log('queryFloorList=======>', 44444);
    },
    // 查询用户配置
    async queryUserConfig() {
      // console.log('queryUserConfig=======>', 11111);
      await manListUserConfig({
        tenantId: this.$commonJs.getTenantId(),
        configCode: "1",
        sceneCode: "5",
      }).then((res) => {
        if (res && res?.length > 0) {
          // console.log(res, '===============>配置');
          const userConfigBizDTO = res[0];
          this.configId = userConfigBizDTO?.configId;
          // console.log(this.configId,userConfigBizDTO, 'configId=====>',userConfigBizDTO?.value.split(','));
          this.checkList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          this.serverList = userConfigBizDTO?.value
            .split(",")
            .map((item) => parseInt(item));
          // console.log(this.checkList, '===============>配置', this.serverList);
        }
        console.log("queryUserConfig=======>", res);
      });
      // console.log('queryUserConfig=======>', 222222);
    },
    // 用户保存配置
    async saveUserConfig(body) {
      await manSaveUserConfig(body).then((res) => {
        console.log(res, "用户保存了==========>");
      });
    },
    getContentQuailty() {
      getContentQuailty(this);
    },
    // 查询分发范围
    getDistributionScope() {
      getDistributionScope(this);
    },
    // 内容性质、文章级别、内容分发数据统一梳理方法
    dataTraversal(list, name) {
      list.map((item) => {
        if (item.id == name) {
          let arr = {};
          arr.attributeCode = item.code;
          arr.attributeType = item.type;
          this.contentAttributes.push(arr);
        }
      });
    },
    // 搜索内容属性处理
    searchDataProcessing() {
      searchDataProcessing(this);
    },
    //查询当前运营所有的业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          // 改版注掉f
          // this.select[13].List.push({
          //   label: item.name,
          //   value: item.id
          // })
          this.businessList.push({
            label: item.name,
            value: item.id,
          });
          this.select.map((subItem) => {
            if (subItem.prop == "business" && subItem.cfgID == 4000) {
              subItem.List.push({
                label: item.name,
                value: item.id,
              });
            }
            return subItem;
          });
        });
      });
    },
    getGeneralLabel() {
      getGeneralLabel(this);
    },
    initData() {
      // 获取tab页的每种类型的数量
      this.getTabNum();
      // ------------------------------ 初始化下拉数据 start -----------------------------------
      // 问答来源查询
      querySource({
        tenantId: this.$commonJs.getTenantId(),
        contentType: this.contentType,
      })
        .then((res) => {
          this.questionFrom = res.map((item) => ({
            value: item.code,
            label: item.desc,
          }));
          res &&
            this.select.map((item) => {
              if (item.prop == "questionSource") {
                item.List = res.map((item) => ({
                  value: item.code,
                  label: item.desc,
                }));
                // this.selectList[item.prop] = ['全部', ...res.map(subItem => subItem.code)];
              }
            });
        })
        .catch((err) => {
          console.log(err);
        });
      // 获取文章状态
      getContentStatus({
        tenantId: this.$commonJs.getTenantId(),
        contentType: this.contentType,
      })
        .then((res) => {
          console.log(
            "来这了======》getContentStatus",
            res,
            this.select,
            this.select
          );
          let itemList = res.map((item) => ({
            value: item.code,
            label: item.desc,
          }));
          // itemList.unshift({value: null, label:"全部" })
          this.answerStatusList = itemList;
          res &&
            this.select.map((item) => {
              if (item.prop == "answerStatus") {
                let itemList = res.map((item) => ({
                  value: item.code,
                  label: item.desc,
                }));
                // itemList.unshift({value: null, label:"全部" })
                console.log(
                  this.answerStatusList,
                  "thisAnswerStatusList=====getContentStatus"
                );
                item.List = itemList;
              }
            });
        })
        .catch((err) => {
          console.log(err);
        });
      // ------------------------------ 初始化下拉数据 end -----------------------------------
      // 获取表格数据
      this.getPageData();
    },
    // --------------------------------- 列表表格相关方法 start ----------------------------------------
    // 请求参数方法
    formData() {
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let lbArr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          lbArr.push(item[item.length - 1]);
        });
      }
      let authorsArr = [];
      let authors = {}; // 回答人的参数
      // 索引
      let contentIndexIds = [];
      if (this.selectList.contentIndexIds.length > 0) {
        contentIndexIds = this.selectList?.contentIndexIds?.map(
          (item) => item?.[item?.length - 1]
        );
      }
      // 判断选择的回答人 是体制内的医生 还是别的
      if (typeof this.selectList.answerer === "number") {
        // 此时选择的是体制内的医生  入参为 docId
        this.selectList.docId = this.selectList.answerer;
        this.selectList.authorNamePrecise = "";
        authors.authorId = this.selectList.docId;
        authors.authorType = 2; // 2-体制内医生
      } else if (this.selectList.answerer.trim() != "") {
        // 此时选择的是体制内的医生  入参为 authorNamePrecise
        this.selectList.authorNamePrecise = this.selectList.answerer;
        this.selectList.docId = "";
        authors.authorNamePrecise = this.selectList.authorNamePrecise;
        authors.authorType = 5; // 5-回答人
      }
      if (authors.authorType) {
        authorsArr.push(authors);
      }
      // if (this.selectList.writerPin.length > 0){
      //   let authorsPin = {
      //     "pins" : [this.selectList.writerPin],
      //     "authorType" : 4
      //   }
      //   authorsArr.push(authorsPin);
      // }

      if (this.selectList.nickname.length > 0) {
        let authorNamePrecise = {
          authorNamePrecise: [this.selectList.nickname],
          authorType: 4,
        };
        authorsArr.push(authorNamePrecise);
      }

      if (this.selectList.hospital.length > 0) {
        let hospitalNamePrecise = {
          hospitalNamePrecise: this.selectList.hospital,
          authorType: 2,
        };
        authorsArr.push(hospitalNamePrecise);
      }

      let contentRelation = {
        contentRelationId: this.selectList.questionId
          ? Number(this.selectList.questionId)
          : "",
        relationType: 1,
      };

      let parameter = {
        tenantId: this.$commonJs.getTenantId(),
        contentType: this.contentType,
        contentName: this.selectList.contentName || null, // 标题
        searchKeyword: this.selectList.searchKeyword || null, // 全文
        auditStatus: this.questionTabList.find(
          (item) => item.name === this.tabActiveName
        ).val,
        contentId: Number(this.selectList.answerId) || null, // 答案id
        contentRelations: [contentRelation] || [], // 关键词
        diseaseIds: this.selectList.symptomsDisease
          ? [this.selectList.symptomsDisease]
          : [], // 疾病id
        startSubmitTime:
          (this.selectList.answerTime && this.selectList.answerTime[0]) || null, // 开始时间
        endSubmitTime:
          (this.selectList.answerTime && this.selectList.answerTime[1]) || null, // 结束时间
        authors: authorsArr, // 回答人信息
        sourceTypes: this.selectList.questionSource
          ? this.selectList.questionSource.filter((item) => item != "全部")
          : null, // 问答来源
        contentStatus:
          this.selectList.answerStatus && this.selectList.answerStatus != "全部"
            ? [this.selectList.answerStatus]
            : [], // 问答状态（1：上线 2：下线）
        publishStatus: this.selectList.publishStatus
          ? this.selectList.publishStatus
          : "",
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        startAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[0]) || null,
        endAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[1]) || null,
        contentAttributes: this.contentAttributes || [], // 内容属性
        businessIds:
          typeof this.selectList.business == "number"
            ? [this.selectList.business]
            : this.selectList.business || [],
        categoryIds:
          typeof this.selectList.categoryId == "number"
            ? [this.selectList.categoryId]
            : this.selectList.categoryId || [],
        channelIds:
          typeof this.selectList.channelId == "number"
            ? [this.selectList.channelId]
            : this.selectList.channelId || [],
        labelIds: lbArr || [],
        auditUser: this.selectList.auditUser || null,
        contentDiseasesNotNull:
          this.selectList.contentDiseasesNotNull &&
          this.selectList.contentDiseasesNotNull != "全部"
            ? this.selectList.contentDiseasesNotNull
            : null,
        isDoctor:
          this.selectList.isDoctor && this.selectList.isDoctor != "全部"
            ? this.selectList.isDoctor
            : null,
        categoryRelationIds: this.selectList.categoryRelationId
          ? [this.selectList.categoryRelationId]
          : [],
        contentIndexIds,
        createUser: this.selectList.writerPin || null,
        sortOrderParams: this.selectList.sortOrderParams,
      };
      return parameter;
    },
    // 筛选项查询数据的方法
    getQueryData() {
      // 如果是 筛选项的查询  则 查询全部 auditStatus
      this.tabActiveName = "全部";
      this.getData();
    },
    getData() {
      this.pagination.currentPage = 1;
      this.getPageData();
    },
    // 页面列表分页获取方法
    getPageData() {
      // 如果是 tab栏 切换 则根据 当前tab栏的  auditStatus 去查
      let params = this.formData();
      if (this.tabActiveName == "全部") {
        params.auditStatus = [];
      }
      queryQuestionList(params)
        .then((res) => {
          const openContentId = sessionStorage.getItem("openContentId");
          if (openContentId) {
            const newVal = res.data.find(
              (item) => item.contentId === +openContentId
            );
            const oldVal = this.tblData.find(
              (item) => item.contentId === +openContentId
            );
            if (
              newVal?.auditInfo?.auditStatus === oldVal?.auditInfo?.auditStatus
            ) {
              return;
            } else {
              if (newVal?.auditInfo?.auditStatus !== 2) {
                // this.pagination.currentPage = 1;
                sessionStorage.setItem("currentPage", 1);
                sessionStorage.removeItem("openContentId");
                this.getPageData();
              }
            }
          }
          this.tabChange = 1;
          this.getTabNum();
          this.tabChange = 0;
          if (res) {
            this.tblData = res.data;
            this.pagination.total = res.totalCount;
            this.pagination.currentPage = res.pageNo;
            this.pagination.pageSize = res.pageSize;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // --------------------------------- 列表表格相关方法 end ----------------------------------------

    // --------------------------------- 搜索表单相关方法 start ----------------------------------------
    // FORM 表单下拉数据 查询回答人（医生）的相关信息
    getDoctor(val) {
      if (val != "") {
        queryDoctorName({
          tenantId: this.$commonJs.getTenantId(),
          doctorName: val.trim(),
        })
          .then((res) => {
            // 如果有结果 代表是体制内的医生
            if (res.length > 0) {
              res &&
                this.select.map((item) => {
                  if (item.prop == "answerer") {
                    item.List = res.map((item) => ({
                      value: item.docId,
                      label: `${item.docName} ${item.hospitalName}`,
                    }));
                  }
                });
            } else {
              // 没有结果 代表是体制外的医生
              this.select.map((item) => {
                if (item.prop == "answerer") {
                  item.List = [];
                }
              });
              this.selectList.answerer = val;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.select.map((item) => {
          if (item.prop == "answerer") {
            item.List = [];
          }
        });
      }
    },
    // FORM 表单下拉数据 查询疾病库名称
    getDiseases(val) {
      if (val != "") {
        queryDiseaseLibraryName({
          tenantId: this.$commonJs.getTenantId(),
          diseaseName: val,
        })
          .then((res) => {
            res &&
              this.select.map((item) => {
                if (item.prop == "symptomsDisease") {
                  item.List = res.data.map((item) => ({
                    value: item.diseaseId,
                    label: item.diseaseName,
                  }));
                }
              });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // FORM 表单下拉数据 清空
    empty() {
      this.sonRefresh = false;
      this.$nextTick(() => {
        this.sonRefresh = true;
      });
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.select.map((item) => {
        if (
          ["symptomsDisease", "categoryId", "channelId"].indexOf(item.prop) > -1
        ) {
          item.List = [];
        }
      });
      this.contentAttributes = [];
      this.getData();
    },
    // --------------------------------- 搜索表单相关方法 end ----------------------------------------

    // --------------------------------- tab页 start ----------------------------------------
    // 文章状态切换查询
    tabHandleClick(tab) {
      this.tabIndex = Number(tab.index);
      this.pagination.currentPage = 1;
      this.getPageData();
    },
    // 获取tab页的每种类型的数量
    getTabNum() {
      let params = this.formData();
      if (this.tabChange === 1) {
        // 2 待审核，3，已通过，4，已驳回
        params.auditStatus = [1, 2, 3, 4];
      }
      queryQuestionStateNum(params)
        .then((res) => {
          res &&
            this.questionTabList.map((item) => {
              item.count =
                item.name === "全部"
                  ? res.allCount
                  : item.name === "待审核"
                  ? res.unAuditCount
                  : item.name === "已通过"
                  ? res.passAuditCount
                  : item.name === "已驳回"
                  ? res.rejectCount
                  : item.name === "已下线"
                  ? res.offlineCount
                  : 0;
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // --------------------------------- tab页 end ----------------------------------------

    // --------------------------------- 表格操作栏事件 start ----------------------------------------
    // 下线取消或者确定按钮
    offlineClickHandler(type) {
      if (type == "one") {
        this.dialogOfflineVisible = false;
      } else if (type == "two") {
        if (this.offLineReasons.trim() === "") {
          this.$message.error("请输入下线理由");
          return false;
        }
        offlineApplication({
          tenantId: Number(this.$commonJs.getTenantId()),
          contentId: this.operatingRow.contentId,
          remark: this.offLineReasons.trim(),
          contentStatus: 2, // 1-上线 2-下线
        })
          .then((res) => {
            if (res) {
              this.$message.success("下线成功");
              this.dialogOfflineVisible = false;
              this.getPageData();
            }
          })
          .catch((err) => {
            this.$message.success("下线失败");
            console.log(err);
          });
      }
    },
    operate(row) {
      const routerObject = this.$router.resolve({
        path: "/questionAnswer/answerEdit",
        query: {
          id: row.contentId,
        },
      });
      if (row.auditInfo.auditStatus !== 2) {
        sessionStorage.setItem("openContentId", row.contentId);
      }
      window.open(routerObject.href, "_blank");
      this.setStorage(row);
    },
    setStorage(row) {
      // 跳转页面存储根据列表通过的更新处不同跳转不同页码
      // 审核通过page不变
      // 编辑提交默认请求第一页
      const page = this.pagination.currentPage;
      sessionStorage.setItem("currentPage", page);
    },
    handlePageVisible(e) {
      if (e.target.visibilityState === "visible") {
        //处于当前页面
        this.pagination.currentPage = sessionStorage.getItem("currentPage");
        this.getPageData();
      }
    },
    redirectTo(row) {
      const urlAddress = "//beta-api.m.jd.com";
      let ret = row.contentRelations.find((item) => item.relationType == 1);
      const url = `https://laputa${
        this.baseUrl == urlAddress ? "-yf" : ""
      }.healthjd.com/content/article/qadetail?id=${ret?.contentId}`;
      window.open(url);
    },

    // --------------------------------- 表格操作栏事件 end ----------------------------------------\
    // --------------------------------- tab操作按钮 start ----------------------------------------\
    // 问答导出
    getOutArticleCategory() {
      getOutArticleCategory(this, 4);
    }, // 上传弹窗关闭
    closeDialog() {
      let fileVal = this.$refs.file;
      fileVal.value = "";
      this.fileResult = "";
      this.fileName = "";
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //导出弹窗关闭
    closeOutDialog() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 导出请求参数方法
    exFormData() {
      if (this.selectList.range != "" || this.selectList.quality != "") {
        this.searchDataProcessing();
      }
      let lbArr = [];
      if (this.selectList.articleLabel) {
        this.selectList.articleLabel.map((item) => {
          lbArr.push(item[item.length - 1]);
        });
      }
      let authorsArr = [];
      let authors = {}; // 回答人的参数
      // 索引
      let contentIndexIds = [];
      if (this.selectList.contentIndexIds.length > 0) {
        contentIndexIds = this.selectList?.contentIndexIds?.map(
          (item) => item?.[item?.length - 1]
        );
      }
      // 判断选择的回答人 是体制内的医生 还是别的
      if (typeof this.selectList.answerer === "number") {
        // 此时选择的是体制内的医生  入参为 docId
        this.selectList.docId = this.selectList.answerer;
        this.selectList.authorNamePrecise = "";
        authors.authorId = this.selectList.docId;
        authors.authorType = 2; // 2-体制内医生
      } else if (this.selectList.answerer.trim() != "") {
        // 此时选择的是体制内的医生  入参为 authorNamePrecise
        this.selectList.authorNamePrecise = this.selectList.answerer;
        this.selectList.docId = "";
        authors.authorNamePrecise = this.selectList.authorNamePrecise;
        authors.authorType = 5; // 5-回答人
      }
      if (authors.authorType) {
        authorsArr.push(authors);
      }
      // if (this.selectList.writerPin.length > 0){
      //   let authorsPin = {
      //     "pins" : [this.selectList.writerPin],
      //     "authorType" : 4
      //   }
      //   authorsArr.push(authorsPin);
      // }

      if (this.selectList.nickname.length > 0) {
        let authorNamePrecise = {
          authorNamePrecise: [this.selectList.nickname],
          authorType: 4,
        };
        authorsArr.push(authorNamePrecise);
      }

      if (this.selectList.hospital.length > 0) {
        let hospitalNamePrecise = {
          hospitalNamePrecise: this.selectList.hospital,
          authorType: 2,
        };
        authorsArr.push(hospitalNamePrecise);
      }

      let contentRelation = {
        contentRelationId: this.selectList.questionId
          ? Number(this.selectList.questionId)
          : "",
        relationType: 1,
      };

      let parameter = {
        tenantId: this.$commonJs.getTenantId(),
        contentType: this.contentType,
        contentName: this.selectList.contentName || null, // 标题
        searchKeyword: this.selectList.searchKeyword || null, // 全文
        auditStatus: this.questionTabList.find(
          (item) => item.name === this.tabActiveName
        ).val,
        contentId: Number(this.selectList.answerId) || null, // 答案id
        contentRelations: [contentRelation] || [], // 关键词
        diseaseIds: this.selectList.symptomsDisease
          ? [this.selectList.symptomsDisease]
          : [], // 疾病id
        startSubmitTime:
          (this.selectList.answerTime && this.selectList.answerTime[0]) || null, // 开始时间
        endSubmitTime:
          (this.selectList.answerTime && this.selectList.answerTime[1]) || null, // 结束时间
        authors: authorsArr, // 回答人信息
        sourceTypes: this.selectList.questionSource
          ? this.selectList.questionSource.filter((item) => item != "全部")
          : null, // 问答来源
        contentStatus:
          this.selectList.answerStatus && this.selectList.answerStatus != "全部"
            ? [this.selectList.answerStatus]
            : [], // 问答状态（1：上线 2：下线）
        publishStatus: this.selectList.publishStatus
          ? this.selectList.publishStatus
          : "",
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        startAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[0]) || null,
        endAuditTime:
          (this.selectList.auditTime && this.selectList.auditTime[1]) || null,
        contentAttributes: this.contentAttributes || [], // 内容属性
        businessIds:
          typeof this.selectList.business == "number"
            ? [this.selectList.business]
            : this.selectList.business || [],
        categoryIds:
          typeof this.selectList.categoryId == "number"
            ? [this.selectList.categoryId]
            : this.selectList.categoryId || [],
        channelIds:
          typeof this.selectList.channelId == "number"
            ? [this.selectList.channelId]
            : this.selectList.channelId || [],
        labelIds: lbArr || [],
        auditUser: this.selectList.auditUser || null,
        contentDiseasesNotNull:
          this.selectList.contentDiseasesNotNull &&
          this.selectList.contentDiseasesNotNull != "全部"
            ? this.selectList.contentDiseasesNotNull
            : null,
        isDoctor:
          this.selectList.isDoctor && this.selectList.isDoctor != "全部"
            ? this.selectList.isDoctor
            : null,
        categoryRelationIds: this.selectList.categoryRelationId
          ? [this.selectList.categoryRelationId]
          : [],
        contentIndexIds,
        createUser: this.selectList.writerPin || null,
      };
      return parameter;
    },
  },
};
</script>
<style lang="scss" scoped>
.answerList {
  .tbl {
    position: relative;
    padding: 20px;
    background: #fff;
    .el-tabs {
      padding: 0;
    }
    .import-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 11;
    }
    .operateBtn {
      position: relative;
      &:before {
        content: " ";
        position: absolute;
        top: 10px;
        left: -6px;
        height: 8px;
        width: 2px;
        background-color: #266cee;
      }
      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }
}
.offlineForm {
  position: relative;
  padding: 20px;
}
.red {
  position: absolute;
  top: 36px;
  left: 44px;
  display: inline-block;
  color: red;
}
.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}
.exportBtn {
  margin-left: 5px;
  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}
</style>
